/* @flow */
import Group from 'entities/Group';
import OwnedClassesListItem from './OwnedClassesListItem';
import * as React from 'react';
import Text from 'components/Text';
// eslint-disable-next-line no-unused-vars
import type { Element } from 'react';

export default class OwnedClassesList extends React.Component<{
  ownedClasses: Group[],
  onActionCompletion: () => void,
}> {
  renderOwnedClassesList(): React.Element {
    const { ownedClasses, onActionCompletion } = this.props;
    if (ownedClasses.length > 0) {
      return ownedClasses.map(ownedClass => {
        return (
          <OwnedClassesListItem
            ownedClass={ownedClass}
            key={ownedClass.id}
            onActionCompletion={onActionCompletion}
          />
        );
      });
    } else {
      return this.renderNoOwnedClasses();
    }
  }

  renderNoOwnedClasses() {
    return (
      <Text align="center" element="div" italic className="OwnedClassesList-noClasses">
        No current classes.
      </Text>
    );
  }

  render() {
    return <div className="OwnedClassesList-table">{this.renderOwnedClassesList()}</div>;
  }
}
